<template>
  <div>
    <div v-if="selectedVideos.length > 0" class="upload-list">
      <div class="video upload-list__video sm" v-for="item in selectedVideos" :key="item.id" >
        <div class="video-overlay">
          <svgicon name="Close" v-if="!item.percent" class="video-close" @click="removeFromSelected(item)"></svgicon>
        </div>
        <div class="video-progress" :style="{'width': item.percent + '%'}" v-if="item.percent < 100"></div>
        <div class="video-status" v-if="item.percent != 100 && item.percent > 0">{{item.percent}}%</div>
        <div class="video-status" v-if="item.percent == 100">
          <div class="video-status__done">
            <svgicon name="Done"></svgicon>
          </div>
          <span v-if="item.toArchive">Archived</span>
          <span v-else>Downloaded</span>
        </div>
        <video :src="item.original_video_url" :poster="item.thumbnail_url" alt="" v-if="item.thumbnail_url" muted></video>
        <img src="../../assets/img/img-processing.png" alt="" v-else>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DownloadVideoFooter",
  props: ['selectedVideos'],
  methods: {
    removeFromSelected(item) {
      this.$emit('removeItem', item);
    },
  },
}
</script>

<style scoped>

</style>
